import { Flex } from '@tremor/react';
import s from './BottomActions.module.scss';
import { useNavigate } from 'react-router-dom';
import {
  OutlinedButton,
  OutlinedButtonProps,
} from '../../Buttons/OutlinedButton/OutlinedButton';
import { useWorkspaceIdFromParams } from '@/hooks/useWorkspaceIdFromParams';
import { useOrganizationStore } from '@/stores/organizationStore';
import { assert } from '@/utils/asserts';
import { NAV_ROUTES } from '@/utils/constants';
import { ValidConnector } from '@/types/Connectors';

type Props = OutlinedButtonProps & {
  isCreating: boolean;
  connectorId?: string;
  isReconnectable?: boolean;
  onUpdate?: () => Promise<void>;
  disabledReconnect?: boolean;
};

export function BottomActions({
  isLoading,
  isCreating,
  disabled,
  connectorId,
  isReconnectable = true,
  disabledReconnect = false,
  onUpdate,
}: Props) {
  const navigate = useNavigate();
  const workspaceId = useWorkspaceIdFromParams();
  assert(workspaceId, 'WorkspaceId is not defined');
  const organization = useOrganizationStore.getState().selectedOrganization;
  assert(organization, 'Organization is not selected');

  return (
    <Flex justifyContent="start" style={{ marginTop: '20px', gap: '20px' }}>
      <OutlinedButton
        onClick={() =>
          navigate(`${NAV_ROUTES.connectorsList}?workspaceId=${workspaceId}`)
        }
        className={s.manualEditCancelButton}
        disabled={disabled || isLoading}
      >
        Go Back
      </OutlinedButton>
      {isReconnectable && connectorId ? (
        <OutlinedButton
          disabled={disabled || isLoading || disabledReconnect}
          className={s.manualEditConnectButton}
          onClick={() => {
            navigate(
              `${NAV_ROUTES.connectorInfo(
                connectorId as ValidConnector,
              )}?workspaceId=${workspaceId}&reconnect=true`,
              {
                relative: 'route',
              },
            );
          }}
        >
          Reconnect
        </OutlinedButton>
      ) : null}
      <OutlinedButton
        isLoading={isLoading}
        disabled={disabled}
        className={s.manualEditConnectButton}
        type={onUpdate ? 'button' : 'submit'}
        onClick={async () => {
          await onUpdate?.();
          isCreating &&
            navigate(`${window.location.pathname}?workspaceId=${workspaceId}`);
        }}
      >
        Next
      </OutlinedButton>
    </Flex>
  );
}
